import { createSelector } from "reselect";
import _ from "lodash";
export const getTemplateList = ({ JobTemplate_reducer }) => {
    return JobTemplate_reducer.templateList;
};
export const selectReportTitles = ({ JobTemplate_reducer }) => {
    return JobTemplate_reducer.reportTitles;
};
export const getProfileList = createSelector(
    [getTemplateList],
    (templates = false) => {
        if (templates) {
            let templateDetailsList = [];
            _.forOwn(templates, e => {
                _.forOwn(e, j => {
                    templateDetailsList.push(j);
                });
            });
            return templateDetailsList;
        } else return [];
    }
);
